export const stepOneData = [
  {
    stepOneHeading: "1. What is a Wedding Loan?",
    paraOne:
      "A wedding loan is a personal loan designed to cover expenses related to weddings. It is an unsecured loan, meaning you don't need to pledge collateral. These loans come with flexible repayment terms and are ideal for funding large-scale expenses without exhausting your savings.",
  },
];

export const stepTwoData = [
  {
    stepTwoHeading: "2. Expenses Covered by Wedding Loans",
    subHeading: '"Manage Wedding Costs Smartly with a Personal Loan"',
    expansesCovered: "Here are some typical expenses covered by wedding loans:",

    expansesList: [
      {
        head: "Venue and Catering: ",
        info: "Pay for banquet halls, decorators, and food services.",
      },
      {
        head: "Jewelry and Attire: ",
        info: "Invest in gold, which doubles as a financial asset, or purchase wedding outfits.",
      },
      {
        head: "Photography and Videography: ",
        info: "Capture your special moments without financial strain.",
      },
      {
        head: "Travel and Honeymoon Expenses: ",
        info: "Cover travel costs for destination weddings or post-wedding vacations.",
      },
      {
        head: " Event Planning: ",
        info: "Hire wedding planners or cover other logistical expenses.",
      },
    ],

    amortizationHeading: [
      {
        head: "Payment Date",
      },
      {
        head: "Principal Component",
      },
      {
        head: "Interest Component",
      },
      {
        head: "Total Monthly Payment ",
      },
      {
        head: "Remaining Balance",
      },
    ],
  },
];

export const stepThreeData = [
  {
    stepThreeHeading: "3. Choosing the Right Lender for Your Wedding Loan",
    subHeading: '"How to Select the Best Lender for Your Wedding Loan"',
    chooseLender: "When choosing a lender, consider these factors:",
    chooseLenderList: [
      {
        head: "Interest Rates and Fees: ",
        info: "Opt for lenders offering competitive rates and minimal processing fees.",
      },
      {
        head: "Repayment Flexibility: ",
        info: "Choose a tenure that matches your repayment capacity.",
      },
      {
        head: "Customer Service: ",
        info: "Check lender reviews for hassle-free application and customer support.",
      },
      {
        head: "Adherence to RBI Guidelines: ",
        info: "Ensure the lender follows ethical practices for repayment and collections.",
      },
    ],
  },
];

export const stepFourData = [
  {
    stepFourHeading: "4. Best Practices When Taking a Wedding Loan",
    subHeading: '"Tips to Make an Informed Decision"',

    tipsList: [
      {
        head: "Assess Your Budget: ",
        info: "Borrow only what you can comfortably repay. Avoid overestimating your requirements.",
      },
      {
        head: "Short Tenures: ",
        info: "Opt for shorter loan tenures to save on interest.",
      },
      {
        head: "Stay Cautious with Digital Loans: ",
        info: "Avoid sharing sensitive data like phone contacts or references while applying for online loans.",
      },
      {
        head: "Emergency Fund: ",
        info: "Ensure you have an emergency fund to avoid complete reliance on loans.",
      },
      {
        head: "Avoid Impulse Purchases: ",
        info: "Stick to planned expenses and avoid overindulgence.",
      },
    ],
  },
];

export const stepFiveData = [
  {
    stepFiveHeading: "5. Comparing Lenders for Wedding Loans",
    subHeading: '"Find the Best Wedding Loan for Your Needs"',

    comparisonHead: "Comparison Table:",

    comparisonTable: [
      {
        head: "Identification:",
      },
    ],

    paraTwo:
      "The lender will conduct a hard credit check, which may temporarily impact your credit score. Some lenders provide an immediate decision, while others may take a few days.",
    paraThree:
      "Some lenders provide an immediate approval decision while others may take a couple days",

    comparingTable: {
      headings: [
        {
          head: "Lender",
        },
        {
          head: "Interest Rate",
        },
        {
          head: "Processing Fees",
        },
        {
          head: "Tenure",
        },
        {
          head: "Special Features",
        },
      ],
      row: [
        {
          bank: "HDFC Bank",
          interest: "10.50% - 15.75%",
          processingFee: "1.5% - 2%",
          tenure: "1 - 5 years",
          spcFeature: "Flexible repayment options",
        },
        {
          bank: "ICICI Bank",
          interest: "11.00% - 16.00%",
          processingFee: "2%",
          tenure: "1 - 5 years",
          spcFeature: "Quick loan disbursement",
        },
        {
          bank: "SBI",
          interest: "9.60% - 14.00%",
          processingFee: "1%",
          tenure: "1 - 6 years",
          spcFeature: "Low processing fees",
        },
        {
          bank: "Axis Bank",
          interest: "10.99% - 17.00%",
          processingFee: "2%",
          tenure: "1 - 5 years",
          spcFeature: "Digital application process",
        },
      ],
    },
  },
];
